import React, { useEffect, useState } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import RefreshIcon from "assets/icons/refresh-icon.png";
import SearchIcon from "assets/icons/search-icon.png";
import UncheckedIcon from "assets/svgIcons/UncheckIcon";
import CheckedIcon from "assets/svgIcons/CheckIcon";
import BigListIcon from "assets/svgIcons/BigList";
import TableListIcon from "assets/svgIcons/TableList";
import { FaQrcode, FaBarcode } from 'react-icons/fa';
import SmallListIcon from "assets/svgIcons/SmallList";
import { Loader } from "commonComponents/Loader/Loader";
import { useTranslation } from "react-i18next";
import {
    Container,
    BtnWrapper,
    SearchWrapper,
    PaginationDropdownWrapper,
    PaginationWrapper,
    ToggleWrapper,
    ActionWrapper,
} from "pages/Fleet/Cars/SearchHeader/SearchHeaderStyled";
import {
    FLEET_GLOBAL_STATES,
    LIST_BY_GLOBAL_STATES,
    CAR_NUMBER_MESSAGE,
    MAP_GLOBAL_STATES,
    UPDATED_CAR_DATA_STATE,
    SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import { useSelector } from "react-redux";
import { useFilteredCarsHook } from "../../../../customHooks/useFilterData";
import { isUserAdmin, isUserBasic, isUserReadOnly, isUserSupport, fleetViewMode } from "constant";
import { Tooltip } from "@mui/material"

export const SearchHeader = ({ className, rowsPerPage, setRowsPerPage, currentPage, setCurrentPage, ...props }) => {
    const { t } = useTranslation();
    const [alignment, setAlignment] = useState("left");
    const { getUserRole } = useSelector((state) => state.commonReducers) || [];
    const [toggleRefresh, setToggleRefresh] = useState(false);
    const {
        carsForMessagesGetter,
        carsGpsSelectorData,
        carsForMessagesGetter2,
        carsGpsSelectorData2,
    } = useHookstate(CAR_NUMBER_MESSAGE);
    const { showTaggedCarArray } = useHookstate(MAP_GLOBAL_STATES);
    const {
        toggleAppInfo,
        toggleSimInfo,
        toggleFleetCarList,
        toggleSelectedCars,
        toggleUnselectedCars,
        selectedCarList,
        selectedCarList2,
        selectFleetCarsData,
        fleetCarNumbers,
        fleetCarNumbersInvert,
    } = useHookstate(FLEET_GLOBAL_STATES);
    const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);
    const { listBy } = useHookstate(LIST_BY_GLOBAL_STATES);
    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
    const displayOptions = React.useMemo(() => [
        "All",
        "15",
        "20",
        "25",
        "30",
        "40",
        "50",
        "100",
        "150",
        "200",
        "250"
    ], []);
    const { getSelectedCarsState: getCarsDataHandler } = useFilteredCarsHook({
        marshalCars: true,
        specialCars: true,
        beverageCars: true,
        fleetCars: true,
        notInUseCars: true,
        notCommunicatingCars: true,
    });

    useEffect(() => {
        if (siteId.get() !== null) {
            selectFleetCarsData.set([]);
            selectedCarList.set([]);
            carsForMessagesGetter.set([]);
            carsForMessagesGetter2.set([]);
        }
    }, [siteId.get()]);

    useEffect(() => {
        let alignmentTab = localStorage.getItem("FleetTabAlignment");
        if (alignmentTab) {
            setAlignment(alignmentTab);
        }
    }, []);

    useEffect(() => {
        let result = fleetCarNumbers
            .get()
            .every((element) => selectedCarList.get().includes(element));
        let resultInvert = fleetCarNumbersInvert
            .get()
            .every((element) => selectedCarList.get().includes(element));

        if (result && fleetCarNumbers.get().length) props.setSelectAll(true);
        if (resultInvert && fleetCarNumbersInvert.get().length)
            props.setSelectAllInvert(true);

        fleetCarNumbers.get().forEach((item) => {
            if (
                fleetCarNumbers.get().length &&
                !selectedCarList.get().includes(item)
            ) {
                props.setSelectAll(false);
            }
        });

        fleetCarNumbersInvert.get().forEach((item) => {
            if (
                fleetCarNumbersInvert.get().length &&
                !selectedCarList.get().includes(item)
            ) {
                props.setSelectAllInvert(false);
            }
        });
    }, [selectedCarList.get()]);

    useEffect(() => {
        const getFleetDataView = localStorage.getItem("FleetDataView");
        const getFleetDataViewParsed = Number(getFleetDataView);
        var fleetCarListValue = getFleetDataViewParsed;

        if (isNaN(getFleetDataViewParsed)) {
            fleetCarListValue = 0;
            setAlignment("left");
        }

        toggleFleetCarList.set(fleetCarListValue);
    }, []);

    const handleRefresh = () => {
        setToggleRefresh(true);
        setTimeout(() => {
            setToggleRefresh(false);
        }, 1000);
    };

    const handleAlignment = (event, newAlignment) => {
        if (newAlignment !== null) {
            setAlignment(newAlignment);
            localStorage.setItem("FleetTabAlignment", newAlignment);
        }
    };

    const handleCheckboxChange = (event) => {
        let allDataOfCars = JSON.parse(updatedCarData.get())?.length ? JSON.parse(updatedCarData.get()) : [];

        let invertfilteredCarData = allDataOfCars?.filter((c) => {
            if ([...fleetCarNumbersInvert.get()].includes(c?.Car?.CarNumber))
                return c?.Car;
        });

        let invertFinalCarsData = invertfilteredCarData?.map((c) => c?.Car);

        let noInvertfilteredCarData = allDataOfCars?.filter((c) => {
            if ([...fleetCarNumbers.get()].includes(c?.Car?.CarNumber)) return c?.Car;
        });

        let noInvertFinalCarsData = noInvertfilteredCarData?.map((c) => c?.Car);

        if (event.target.name === "unselected") {
            if (!props.invert) {
                props.setSelectAll(false);
                const filteredArray = selectedCarList
                    .get()
                    .filter((element) => !fleetCarNumbers.get().includes(element));
                selectedCarList.set([...filteredArray]);

                selectFleetCarsData.set((c) =>
                    c?.filter((c) => ![...fleetCarNumbers.get()].includes(c?.CarNumber))
                );
            }

            if (props.invert) {
                props.setSelectAllInvert(false);
                const filteredArray = selectedCarList
                    .get()
                    .filter((element) => !fleetCarNumbersInvert.get().includes(element));

                selectedCarList.set([...filteredArray]);
                selectFleetCarsData.set((c) =>
                    c?.filter(
                        (c) => ![...fleetCarNumbersInvert.get()].includes(c?.CarNumber)
                    )
                );
            }

            toggleSelectedCars.set(false);
            toggleUnselectedCars.set(true);
            selectedCarList2.set([]);
            carsForMessagesGetter.set([]);
            carsForMessagesGetter2.set([]);
            carsGpsSelectorData.set([]);
            carsGpsSelectorData2.set([]);
            showTaggedCarArray.set([]);
        } else {
            if (!props.invert) {
                props.setSelectAll(true);
                if (props.selectAllInvert) {
                    selectFleetCarsData.set([
                        ...noInvertFinalCarsData,
                        ...invertFinalCarsData,
                    ]);
                    selectedCarList.set([
                        ...fleetCarNumbers.get(),
                        ...fleetCarNumbersInvert.get(),
                    ]);
                } else {
                    selectFleetCarsData.set(noInvertFinalCarsData);
                    selectedCarList.set([...fleetCarNumbers.get()]);
                }
            }

            if (props.invert) {
                props.setSelectAllInvert(true);
                if (props.selectAll) {
                    selectFleetCarsData.set([
                        ...noInvertFinalCarsData,
                        ...invertFinalCarsData,
                    ]);
                    selectedCarList.set([
                        ...fleetCarNumbers.get(),
                        ...fleetCarNumbersInvert.get(),
                    ]);
                } else {
                    selectFleetCarsData.set(invertFinalCarsData);
                    selectedCarList.set([...fleetCarNumbersInvert.get()]);
                }
            }

            let carsNumberData = [];
            let carsGpsiCarIdData = [];
            if (selectedCarList.get().length > 0) {
                carsNumberData = selectFleetCarsData.get().map((item) => item?.CarNumber);
                carsGpsiCarIdData = selectFleetCarsData.get().map((item) => item?.GpsiCarId);
            } else {
                if (getCarsDataHandler.get().length !== 0) {
                    carsNumberData = getCarsDataHandler.get().map((item) => item?.Car?.CarNumber);
                    carsGpsiCarIdData = getCarsDataHandler.get().map((item) => item?.Car?.GpsiCarId);
                } else {
                    let carData2 = JSON.parse(updatedCarData.get());
                    carsNumberData = carData2.map((item) => item?.Car?.CarNumber);
                    carsGpsiCarIdData = carData2.map((item) => item?.Car?.GpsiCarId);
                }
            }

            carsForMessagesGetter.set(carsNumberData);
            carsForMessagesGetter2.set(carsNumberData);
            carsGpsSelectorData.set(carsGpsiCarIdData);
            carsGpsSelectorData2.set(carsGpsiCarIdData);
            selectedCarList2.set(carsNumberData);
            showTaggedCarArray.set(carsNumberData);
            toggleSelectedCars.set(true);
            toggleUnselectedCars.set(false);
        }
    };

    const handleToggleSimInfo = () => {
        toggleSimInfo.set(!toggleSimInfo.get());
    };

    const handleToggleAppInfo = () => {
        toggleAppInfo.set(!toggleAppInfo.get());
    };

    const handleToggleSmallList = () => {
        toggleFleetCarList.set(fleetViewMode.SmallList);
        localStorage.setItem("FleetDataView", fleetViewMode.SmallList);
    };

    const handleToggleGridList = () => {
        toggleFleetCarList.set(fleetViewMode.GridList);
        localStorage.setItem("FleetDataView", fleetViewMode.GridList);
    };

    const handleToggleTableList = () => {
        toggleFleetCarList.set(fleetViewMode.TableList);
        localStorage.setItem("FleetDataView", fleetViewMode.TableList);
    };

    let countMsg = props.invert ? "No " : "";
    countMsg =
        countMsg +
        listBy.get().charAt(0).toUpperCase() +
        listBy.get().slice(1).toLocaleLowerCase() +
        " detected (" +
        props.count +
        ")";
    const totalPages = React.useMemo(() => {
        if (rowsPerPage === "All") return 1;
        return Math.ceil(props.count / Number(rowsPerPage));
    }, [props.count, rowsPerPage]);
    return (
        <>
            {toggleRefresh ? (
                <Loader />
            ) : (
                <>
                    <Container className={className}>
                        <ActionWrapper>
                            <BtnWrapper>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            disabled={
                                                isUserBasic(getUserRole && getUserRole?.Role) ||
                                                    isUserReadOnly(getUserRole && getUserRole?.Role) ||
                                                    props.invert
                                                    ? props.disableselectAllInvert
                                                    : props.disableselectAll
                                            }
                                            default
                                            icon={<UncheckedIcon />}
                                            checkedIcon={<CheckedIcon />}
                                            checked={
                                                props.invert ? props.selectAllInvert : props.selectAll
                                            }
                                            name="selected"
                                            onClick={(e) => {
                                                handleCheckboxChange(e);
                                            }}
                                        />
                                    }
                                    label={t("Select_all_cars")}
                                />
                                <FormControlLabel
                                    className="unselect-checkbox "
                                    control={
                                        <Checkbox
                                            disabled={
                                                isUserBasic(getUserRole && getUserRole?.Role) ||
                                                    isUserReadOnly(getUserRole && getUserRole?.Role) ||
                                                    props.invert
                                                    ? props.disableselectAllInvert
                                                    : props.disableselectAll
                                            }
                                            default
                                            icon={<UncheckedIcon />}
                                            checkedIcon={<CheckedIcon />}
                                            name="unselected"
                                            checked={
                                                props.invert ? !props.selectAllInvert : !props.selectAll
                                            }
                                            onChange={(e) => {
                                                handleCheckboxChange(e);
                                            }}
                                        />
                                    }
                                    label={t("Unselect_all_cars")}
                                />
                                <label className="car-count">
                                    {listBy.get() !== "NONE" && countMsg}
                                </label>
                            </BtnWrapper>
                            <BtnWrapper className="with-search">
                                <button
                                    disabled={
                                        isUserBasic(getUserRole && getUserRole?.Role) ||
                                        isUserReadOnly(getUserRole && getUserRole?.Role)
                                    }
                                    onClick={handleRefresh}
                                >
                                    <img src={RefreshIcon} alt="refresh-icon" />{" "}
                                    {t("Refresh_cars")}
                                </button>
                                <SearchWrapper>
                                    <input
                                        type="text"
                                        placeholder={t("Search_car_no")}
                                        value={props.getFleetcarsInput}
                                        onChange={(e) => props.setGetFleetcarsInput(e.target.value)}
                                    />
                                    <img src={SearchIcon} alt="search-icon" />
                                </SearchWrapper>
                                <PaginationDropdownWrapper>
                                    <span>Display</span>
                                    <select
                                        value={rowsPerPage}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setRowsPerPage(value);
                                        }}>
                                        {displayOptions.map((opt) => (
                                            <option key={opt} value={opt}>
                                                {opt}
                                            </option>
                                        ))}
                                    </select>
                                    <span className="light-text">rows on a page</span>
                                </PaginationDropdownWrapper>
                                {rowsPerPage !== "All" && props.count > Number(rowsPerPage) && (
                                    <PaginationWrapper>
                                        <button
                                            onClick={() => setCurrentPage(1)}
                                            disabled={currentPage === 1}>
                                            {"<<"}
                                        </button>
                                        <button
                                            onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                                            disabled={currentPage === 1}>
                                            {"<"}
                                        </button>
                                        <span>
                                            Page {currentPage} of {totalPages}
                                        </span>
                                        <button
                                            onClick={() =>
                                                setCurrentPage((p) => Math.min(p + 1, totalPages))
                                            }
                                            disabled={currentPage === totalPages}>
                                            {">"}
                                        </button>
                                        <button
                                            onClick={() => setCurrentPage(totalPages)}
                                            disabled={currentPage === totalPages}>
                                            {">>"}
                                        </button>
                                    </PaginationWrapper>
                                )}
                            </BtnWrapper>
                        </ActionWrapper>
                        {toggleFleetCarList.get() === fleetViewMode.TableList && (isUserAdmin(getUserRole?.Role) || isUserSupport(getUserRole?.Role)) && <> <ToggleButton
                            title={t("Toggle_Sim_Info")}
                            value="left"
                            aria-label="left aligned"
                            onClick={handleToggleSimInfo}
                            style={{ background: toggleSimInfo.get() ? "#c1e1e0" : "#028597", height: 30 }}
                        >
                            <FaBarcode sx={{ backgroundImage: "linear-gradient(to bottom, #ffffff, #c1e1e0)", borderColor: "#014c56" }} fill={toggleSimInfo.get() ? "black" : "white"} />
                        </ToggleButton>
                            <ToggleButton
                                title={t("Toggle_App_Info")}
                                value="left"
                                aria-label="left aligned"
                                onClick={handleToggleAppInfo}
                                style={{ background: toggleAppInfo.get() ? "#c1e1e0" : "#028597", height: 30 }}
                            >
                                <FaQrcode sx={{ backgroundImage: "linear-gradient(to bottom, #ffffff, #c1e1e0)", borderColor: "#014c56" }} fill={toggleAppInfo.get() ? "black" : "white"} />
                            </ToggleButton>
                        </>}
                        <ToggleWrapper className="display toggle">
                            <ToggleButtonGroup
                                value={alignment}
                                exclusive
                                onChange={handleAlignment}
                                aria-label="text alignment"
                            >
                                <Tooltip title={t("Compact_Grid_View")} arrow>
                                    <div>
                                        <ToggleButton
                                            value="left"
                                            aria-label="compact grid view"
                                            onClick={handleToggleSmallList}
                                        >
                                            <SmallListIcon fill="#636F7C" />
                                        </ToggleButton>
                                    </div>
                                </Tooltip>

                                <Tooltip title={t("Full_Grid_View")} arrow>
                                    <div>
                                        <ToggleButton
                                            value="center"
                                            aria-label="full grid view"
                                            onClick={handleToggleGridList}
                                        >
                                            <BigListIcon fill="#636F7C" />
                                        </ToggleButton>
                                    </div>
                                </Tooltip>

                                <Tooltip title={t("Table_View")} arrow>
                                    <div>
                                        <ToggleButton
                                            value="right"
                                            aria-label="table view"
                                            onClick={handleToggleTableList}
                                        >
                                            <TableListIcon fill="#636F7C" />
                                        </ToggleButton>
                                    </div>
                                </Tooltip>
                            </ToggleButtonGroup>
                        </ToggleWrapper>
                    </Container>
                </>
            )}
        </>
    );
};
